<template>
    <div>
      <div :style="{'height': iframeHeight}" v-html="meta.source_code">

      </div>
      <!-- <iframe
        allow="camera; microphone; fullscreen; speaker; display-capture"
        width="100%"
        :style="{'height': iframeHeight}"
        :src="meta.meeting_url"
        frameborder="0"
        allowfullscreen
      ></iframe> -->
    </div>
</template>
<script>
import i18n from "@/i18n";
export default {
    name: "iFrame",
    props: {
        meta: {
            type: Object,
            default: null
        }
    },
    mounted() {
      this.showNotification()
    },
    computed: {
      iframeHeight() {
        // const isFullScreenWithEmbed = this.meta.isEmbedMode && this.meta.isFullScreenMode
        return this.meta.isFullScreenMode ? '98vh' :'600px'
      }
    },
    methods: {
      /** Show notification: Event is about to start */
      showNotification() {
        this.$store.dispatch("app/showSupportNotification", {
          screener_id: this.meta.screener_id,
          message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
        });
      }
    }
}
</script>
